import LeafletMapsContainer from "../../../components/miscellaneous/maps/leafletMaps";

const LeafletMap = () => {
  return <LeafletMapsContainer />;
};

export default LeafletMap;
